function initLanguageSwitcher() {
	const switcher = document.querySelector('.language-switcher');
	if (!switcher) return;

	const trigger = switcher.querySelector('.language-switcher-trigger');
	if (!trigger) return;

	const desktopMq = window.matchMedia('(min-width: 1200px)');

	trigger.addEventListener('click', (e) => {
		if (!desktopMq.matches) return;
		e.stopPropagation();
		switcher.classList.toggle('open');
	});

	document.addEventListener('click', (e) => {
		if (!switcher.classList.contains('open')) return;
		if (switcher.contains(e.target)) return;
		switcher.classList.remove('open');
	});
}
